const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
    <path d="M7.5 2h9A5.5 5.5 0 0 1 22 7.5v9A5.5 5.5 0 0 1 16.5 22h-9A5.5 5.5 0 0 1 2 16.5v-9A5.5 5.5 0 0 1 7.5 2Zm0 1.5A4 4 0 0 0 3.5 7.5v9A4 4 0 0 0 7.5 20.5h9a4 4 0 0 0 4-4v-9a4 4 0 0 0-4-4h-9Zm9 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm-4 1.5A4.5 4.5 0 1 1 7.5 14.5 4.5 4.5 0 0 1 12.5 6.5Zm0 1.5a3 3 0 1 0 3 3 3 3 0 0 0-3-3Z" />
  </svg>
);

const YoutubeIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
    <path d="M21.8 7.2a2.7 2.7 0 0 0-1.9-1.9C17.9 4.8 12 4.8 12 4.8s-5.9 0-7.9.5a2.7 2.7 0 0 0-1.9 1.9A28.7 28.7 0 0 0 2 12a28.7 28.7 0 0 0 .2 4.8 2.7 2.7 0 0 0 1.9 1.9c2 .5 7.9.5 7.9.5s5.9 0 7.9-.5a2.7 2.7 0 0 0 1.9-1.9A28.7 28.7 0 0 0 22 12a28.7 28.7 0 0 0-.2-4.8Zm-12.1 8.3V8.5l5.8 3.5-5.8 3.5Z" />
  </svg>
);

const LinkedinIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
    <path d="M5.5 3A2.5 2.5 0 0 0 3 5.5v13A2.5 2.5 0 0 0 5.5 21h13a2.5 2.5 0 0 0 2.5-2.5v-13A2.5 2.5 0 0 0 18.5 3h-13Zm3.5 5.5H6v9h3V8.5Zm-1.5-4A1.5 1.5 0 1 1 6.5 8 1.5 1.5 0 0 1 7.5 4.5Zm5.5 4.5c-1 0-1.5.5-1.8 1.1V8.5h-3v9h3v-5c0-1 0-2.3 1.5-2.3s1.6 1.2 1.6 2.4v4.9h3v-5.2c0-2.8-1.5-4.1-3.3-4.1Z" />
  </svg>
);

export const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Portfolio', path: '/portfolio' },
  { label: 'Testimonials', path: '/testimonials' },
  { label: 'Contact', path: '/contact' },
  { label: 'Services', path: '/services' },
];

export const services = [
  {
    title: 'Website Development',
    description: 'Modern, responsive websites built for conversion and long-term growth.',
  },
  {
    title: 'SaaS Development',
    description: 'Secure, scalable SaaS platforms designed to support fast-growing products.',
  },
  {
    title: 'Business Applications',
    description: 'Custom internal tools and enterprise-grade software for better operations.',
  },
  {
    title: 'Automation Solutions',
    description: 'Workflows, bots, and integrations that reduce manual work and speed delivery.',
  },
];

export const processSteps = ['Idea', 'Design', 'Build', 'Scale'];

export const featuredProjects = [
  {
    title: 'Happy Kidzy Club School Website',
    description: 'A premium school brand experience with performance-first design.',
    tech: ['React', 'Tailwind', 'CMS'],
    live: 'https://www.happykidzclub.com/index.html',
  },
  {
    title: 'Face Analysis System',
    description: 'Forensics-grade image analysis powered by Python and ML pipelines.',
    tech: ['Python', 'OpenCV', 'Flask'],
  },
  {
    title: 'Revup Bikes',
    description: 'A dynamic marketplace experience for premium bike rentals and sales.',
    tech: ['Express', 'Node', 'React'],
    live: 'https://revupbikes.com',
  },
];

export const deliveredProjects = [
  {
    title: 'Happy Kidzy Club School Website',
    description: 'Public-facing academy website built for easy content updates and admissions.',
    tech: ['React', 'Tailwind', 'CMS'],
    tag: 'Client Project',
    live: 'https://www.happykidzclub.com/index.html',
  },
  {
    title: 'Face Analysis System',
    description: 'Forensics solution using Python for secure image analysis and reporting.',
    tech: ['Python', 'Machine Learning', 'Flask'],
    tag: 'Client Project',
  },
  {
    title: 'Revup Bikes',
    description: 'Rental marketplace with fast search, booking flows, and modern UX.',
    tech: ['Express JS', 'React', 'Stripe'],
    tag: 'Client Project',
    live: 'https://revupbikes.com',
  },
  {
    title: 'Placement App',
    description: 'Android placement tracker delivering mobile-first student workflows.',
    tech: ['Android', 'Java', 'Firebase'],
    tag: 'Client Project',
  },
  {
    title: 'Alostappen Portfolio',
    description: 'F1 content creator portfolio with storytelling, highlights, and media.',
    tech: ['React', 'Next', 'Animation'],
    tag: 'Client Project',
    live: 'https://alostappen.vercel.app/',
  },
];

export const ongoingProjects = [
  {
    title: 'COS - Campus Operating System',
    description: 'A unified campus platform for management, engagement, and analytics.',
    tech: ['Java', 'Spring Boot', 'React'],
    tag: 'Product',
  },
  {
    title: 'ROS - Rental Operating System',
    description: 'A booking engine and fleet management product for rental businesses.',
    tech: ['Node', 'React', 'PostgreSQL'],
    tag: 'Product',
    live: 'https://ros.geniuskods.com',
  },
  {
    title: 'MyWorld',
    description: 'Internal organization tool for teams, workflows, and knowledge sharing.',
    tech: ['React', 'Python', 'REST APIs'],
    tag: 'Product',
  },
  {
    title: 'Banjara Community Heritage App',
    description: 'A cultural storytelling app connecting heritage with local communities.',
    tech: ['React Native', 'Firebase', 'Design'],
    tag: 'Product',
  },
];

export const testimonials = [
  {
    name: 'Priya Sharma',
    designation: 'Brand Director',
    message: 'Genius KODS delivered our product exactly on time with a level of polish that impressed stakeholders.',
    rating: 5,
  },
  {
    name: 'Rohit Mehta',
    designation: 'Operations Lead',
    message: 'Their automation solutions reduced manual effort and accelerated our launch process.',
    rating: 5,
  },
  {
    name: 'Anjali Rao',
    designation: 'Startup Founder',
    message: 'The team translated my ideas into a scalable product without compromising on design.',
    rating: 4,
  },
];

export const techStack = ['Java', 'Spring Boot', 'React', 'Python', 'Android'];

export const socialLinks = [
  { label: 'Instagram', url: 'https://instagram.com/geniuskods', icon: InstagramIcon },
  { label: 'YouTube', url: 'https://youtube.com/@GeniusKODS', icon: YoutubeIcon },
  { label: 'LinkedIn', url: 'https://linkedin.com/company/genius-kods', icon: LinkedinIcon },
];

export const contact = {
  email: ['contact@geniuskods.com', 'geniuskods@gmail.com'],
  phone: ['+91 83906 87612', '+91 92700 96329'],
  location: 'Pune, India',
}
